export const LOAD_EXCEPTIONS_LOADING = 'REDUX_SAGA_LOAD_EXCEPTIONS_LOADING';
export const LOAD_EXCEPTIONS_SUCCESS = 'REDUX_SAGA_LOAD_EXCEPTIONS_SUCCESS';
export const LOAD_EXCEPTIONS_ERROR = 'REDUX_SAGA_LOAD_EXCEPTIONS_ERROR';

export const loadExceptions = () => dispatch => {
    dispatch({ type: LOAD_EXCEPTIONS_LOADING });
};